export default "__VITE_ASSET__BkzraC1L__";